/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Divider,
  Input,
  Modal,
  Row,
  Tooltip,
  Typography,
  Switch,
  AutoComplete,
  Badge,
  // DatePicker,
  FloatButton,
  Collapse,
  Select,
  Image,
  Table,
  Spin,
} from "antd";
import { toast, ToastContainer } from "react-toastify";
import PaymentOutLogo from "../../assets/images/no-purchases-empty.svg";
import {
  SettingOutlined,
  ArrowLeftOutlined,
  QuestionCircleOutlined,
  DownCircleOutlined,
  SearchOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom";
// import { Prompt, useHistory } from "react-router-dom";
import useBeforeUnload from "../../components/Prompting";
import "./index.css";
import { paymentFaqList } from "./data";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { BiCalendar } from "react-icons/bi";
import useMedia from "use-media-antd-query";
import { useDispatch, useSelector } from "react-redux";
import {
  // createPaymentInList,
  loadPartyAccountList,
  loadPaymentInList,
  loadPaymentInListRecordsMetaData,
  loadPaymentSettledList,
} from "../../store/payment-in/actions";
import { loadParties } from "../../store/parties/actions";
import moment from "moment";
import api from "../../helpers";
import SimpleReactValidator from "simple-react-validator";
import PropTypes from "prop-types";
import { loadPrefixSettingsList } from "../../store/expenses/actions";

const CreatePaymentIn = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const media = useMedia();

  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  //state values from list table
  const updatedPaymentData =
    props.location && props.location.state
      ? props.location.state.paymentData
      : "";

  //user details from login
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const createdById = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";
  const paymentPrefixList = {
    organizationId: organizationId,
    isType: "isPaymentIn",
  };

  //Initial state section
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [paymentDate, setPaymentDate] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState([]);
  const [paymentModeId, setPaymentModeId] = useState("");
  const [accountList, setAccountList] = useState([]);
  const [paymentInData, setPaymentInData] = useState({
    paymentAmount: "",
    _id: "",
    partyId: "",
    accountId: "",
    // paymentModeId: "",
    // paymentAmount: "",
    paymentInNo: "",
    description: "",
  });
  const today = new Date();
  today.setDate(today.getDate());
  useEffect(() => {
    const initialPaymentModeId = "66c9bd5ab3fca462ca48a87e";
    dispatch(loadPaymentInListRecordsMetaData());
    dispatch(
      loadParties({
        organizationId: organizationId,
      })
    );
    setPaymentMode("Cash");
    setPaymentModeId(initialPaymentModeId);
    setPaymentDate(today);
    dispatch(loadPrefixSettingsList(paymentPrefixList));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //reducer state

  const {
    recordsMetaData = {},
    payment_settled_list = [],
    party_account_list = [],
  } = useSelector((state) => state.PaymentIn);
  const { parties_list = [] } = useSelector((state) => state.Parties);
  const { prefix_settings_list = [] } = useSelector((state) => state.Expenses);
  //party options
  const partyOptions =
    parties_list && parties_list.length > 0
      ? parties_list.map((data) => {
          return {
            label: data.partyName,
            value: data._id,
            currentBalance: data.currentBalance,
          };
        })
      : [];

  const partyAccountOptions =
    party_account_list && party_account_list.length > 0
      ? party_account_list.map((data) => {
          return {
            accountName: data.accountName,
            openingBalance: data.openingBalance,
            asOfDate: data.asOfDate,
            accountNumber: data.accountNumber,
            bankName: data.bankName,
            bankBranch: data.bankBranch,
            ifscCode: data.ifscCode,
            accountHolderName: data.accountHolderName,
            upiId: data.upiId,
            label: data.accountName,
            value: data._id,
          };
        })
      : [];

  //settings States data
  const [paymentInNo, setPaymentInNo] = useState("");
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [paymentFaq, setPaymentFaq] = useState(false);
  const [pageRouting, setPageRouting] = useState(false);
  const [cancelConfirmation, setCancelConfirmation] = useState(false);
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);
  const [prefixValidations, setPrefixValidations] = useState(false);
  const [prefixSettings, setPrefixSettings] = useState({
    prefix: "",
    seqNo: "",
  });

  const handleChange = (e) => {
    setPrefixSettings({
      ...prefixSettings,
      [e.target.name]: e.target.value,
    });
  };

  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  //Search purchase
  const [partyList, setPartyList] = useState([]);
  const [updatedCurrentBalance, setUpdatedCurrentBalance] = useState("");
  const [partyListSelected, setPartyListSelected] = useState(false);

  const handlePaymentChange = (e) => {
    setPaymentInData({
      ...paymentInData,
      [e.target.name]: e.target.value,
    });
  };

  const currentBalanceList =
    !isEmpty(updatedPaymentData) && !isEmpty(paymentInData.partyId)
      ? updatedCurrentBalance
      : (!isEmpty(partyList) || partyList.length > 0) && partyOptions.length > 0
      ? partyOptions.find((data) => data.value === partyList)
      : "";

  const currentBalance = !isEmpty(currentBalanceList)
    ? currentBalanceList.currentBalance
    : "";

  //payment settles options
  //header columns

  const HeaderData = [
    {
      key: "createdAt",
      title: <p className="header-sales-invoice font-semibold">Date</p>,
      dataIndex: "createdAt",
      width: "15%",
      sorter: (a, b) => a.createdAt.length - b.createdAt.length,
    },
    {
      key: "dueDate",
      title: <p className="header-sales-invoice font-semibold">Due Date</p>,
      dataIndex: "dueDate",
      width: "15%",
    },
    // {
    //   key: "paymentNumber",
    //   title: <p className="header-sales-invoice font-semibold">Payment No</p>,
    //   dataIndex: "paymentNumber",
    // },
    {
      key: "salesinvoiceNo",
      title: <p className="header-sales-invoice font-semibold">Invoice No</p>,
      dataIndex: "salesinvoiceNo",
      width: "16%",
    },
    // {
    //   key: "partyName",
    //   title: <p className="header-sales-invoice font-semibold">Party Name</p>,
    //   dataIndex: "partyName",
    // },
    // {
    //   key: "balanceAmount",
    //   title: <p className="header-sales-invoice font-semibold">Balance</p>,
    //   dataIndex: "balanceAmount",
    // },
    {
      key: "netTotalAmount",
      title: <p className="header-sales-invoice font-semibold">Amount</p>,
      dataIndex: "netTotalAmount",
      width: "24%",
      render: (record, text, row) => {
        return (
          <div className="flex">
            <p className="mr-1">₹. </p>
            <p
              style={{
                fontFamily: "Poppins",
                marginTop: "0.5px",
                marginRight: "3px",
              }}
            >
              {text.netTotalAmount &&
                text.netTotalAmount.toLocaleString("en-IN")}
            </p>
            (
            <div className="flex">
              <p className="mr-1">₹. </p>
              <p
                style={{
                  fontFamily: "Poppins",
                  marginTop: "0.5px",
                  color: "red",
                }}
              >
                {text.balanceAmount &&
                  text.balanceAmount.toLocaleString("en-IN")}
              </p>
            </div>
            )
          </div>
        );
      },
    },
    {
      key: "amountreceived",
      title: <p className="header-sales-invoice font-semibold">Settled</p>,
      dataIndex: "amountreceived",
      width: "24%",
      render: (record, text) => {
        return (
          <div className="flex">
            <p className="mr-1">₹. </p>
            <p
              style={{
                fontFamily: "Poppins",
                marginTop: "0.5px",
              }}
            >
              {text.amountreceived &&
                text.amountreceived.toLocaleString("en-IN")}
            </p>
          </div>
        );
      },
    },
  ];

  //purchase rows

  const [paymentSettledRows, setPaymentSettledRows] = useState([
    {
      _id: "",
      key: "",
      netTotalAmount: "",
      netTotalAmountValue: "",
      amountreceivedmode: "",
      balanceAmount: "",
      balanceAmountValue: "",
      amountreceived: "",
      amountreceivedValue: "",
      authorizedsignature: "",
      autoamountroundoff: "",
      beforeautoroundoffamount: "",
      charge: "",
      createdAt: "",
      createdBy: "",
      financialyearId: "",
      isHistory: "",
      items: "",
      notes: "",
      organizationId: "",
      // amount: "",
      salesinvoiceNo: "",
      salesinvoiceNoValue: "",
      salesinvoiceDate: "",
      createdAtValue: "",
      salesinvoiceDateValue: "",
      partyId: "",
      siId: "",
      partyAddress: "",
      dueDate: "",
      dueDateValue: "",
      status: "",
      subtotalamount: "",
      taxableAmonut: "",
      termsandconditions: "",
      totaltax: "",
      totaltaxableValue: "",
      transActionType: "",
      type: "",
      updatedAt: "",
      vendorAddress: "",
      vendorCity: "",
      // partyId: "",
      partyName: "",
      selected: false,
      partyNameValue: "",
    },
  ]);

  // const paymentAmountInitial = paymentAmount;
  const updateTable = (rows, paymentAmount) => {
    // let initialRemainingPayment = paymentAmount;
    let remainingPayment = paymentAmount;

    // rows = paymentSettledRows
    // rows.forEach((row) => {
    //   if (
    //     paymentAmount > 0 &&
    //     // (paymentAmount > 0 || !isEmpty(paymentAmount)) &&
    //     remainingPayment < paymentAmountInitial
    //   ) {
    //     const deductAmount = row.balanceAmount - remainingPayment

    //     row.balanceAmount -= Math.round(Number(deductAmount));
    //     row.amountreceived =
    //       Number(row.amountreceived || 0) - Math.round(Number(deductAmount));

    //     // Subtract from the remaining payment
    //     // remainingPayment -= deductAmount;
    //   } else if (paymentAmount > 0 || !isEmpty(paymentAmount)) {
    //     // Calculate how much to deduct from the current row's balance
    //     const deductAmount = Math.min(row.balanceAmount, remainingPayment);

    //     // Update the row's balanceAmount and receiveAmount
    //     row.balanceAmount -= Math.round(Number(deductAmount));
    //     row.amountreceived =
    //       Number(row.amountreceived || 0) + Math.round(Number(deductAmount));
    //     // row.selected = true
    //     // Subtract from the remaining payment
    //     remainingPayment -= Math.round(Number(deductAmount));
    //   } else {
    //     row.balanceAmount = Number(row.balanceAmountValue);
    //     row.amountreceived = Number(row.amountreceivedValue);
    //   }
    // });

    // Reset previous values to avoid accumulation issues
    rows.forEach((row) => {
      row.balanceAmount = row.balanceAmountValue;
      row.amountreceived = row.amountreceivedValue; // Use previous received value instead of 0
    });

    // Apply payment to only selected rows
    rows.forEach((row) => {
      if (remainingPayment > 0) {
        const deductAmount = Math.min(row.balanceAmount, remainingPayment);

        row.balanceAmount -= deductAmount;
        row.amountreceived = (row.amountreceived || 0) + deductAmount; // Retain old received amount

        remainingPayment -= deductAmount;
      }
    });

    // Handle case where payment amount is reduced (reverse allocation)
    if (remainingPayment < 0) {
      remainingPayment = Math.abs(remainingPayment);

      for (let i = rows.length - 1; i >= 0; i--) {
        const row = rows[i];

        if (remainingPayment > 0 && row.amountreceived > 0) {
          const refundAmount = Math.min(row.amountreceived, remainingPayment);

          row.balanceAmount += refundAmount;
          row.amountreceived -= refundAmount;

          remainingPayment -= refundAmount;
        }
      }
    }

    const selectedRowsList = rows.filter(
      (data) => data.amountreceived !== data.amountreceivedValue
    );
    const selectedRows = selectedRowsList.map((data) => data._id);
    // console.log(selectedRows, "update table rows")
    setSelectedRowKeys(selectedRows);

    return rows; // Return the updated table
  };
  const handlePaymentAmountChange = (e) => {
    const payment = e.target.value;
    const re = /^[0-9\b]+$/;
    if (payment === "" || re.test(payment)) {
      const paymentAmountValue = re.test(payment);
      // this.setState({ payment: e.target.value });
      setPaymentAmount(e.target.value);
      console.log(paymentAmountValue, "paymentAmountValue");
      const updatedSelectedRows = updateTable(
        paymentSettledRows,
        e.target.value
      );
      // setPaymentSettledRows(updatedRows);
      setPaymentSettledRows(updatedSelectedRows);
    }

    // const remainingPayment = paymentAmount;
  };
  // const [previousPayment, setPreviousPayment] = useState(0);

  // Handle Checkbox Selection
  // const handleCheckboxChange = (id, isChecked) => {
  //   let remainingPayment = paymentAmount;

  //   setPaymentSettledRows((prevData) =>
  //     prevData.map((row) => {
  //       if (id.some((data) => data == row._id)) {
  //         // console.log(row, "row")
  //         const deductAmount = Math.min(row.balanceAmount, remainingPayment);

  //         console.log(deductAmount, "deductAmount");
  //         remainingPayment -= deductAmount;
  //         return isChecked
  //           ? {
  //               ...row,
  //               selected: true,
  //               amountreceived: row.amountreceived + deductAmount,
  //               // Received = payment amount
  //               balanceAmount: deductAmount, // Balance = 0
  //             }
  //           : {
  //               ...row,
  //               selected: false,
  //               amountreceived: row.amountreceivedValue, // Reset received
  //               balanceAmount: row.balanceAmountValue, // Balance = payment amount
  //               // balanceAmount: row.balanceAmount + paymentAmount, // Balance = payment amount
  //             };
  //         // return isChecked
  //         //   ? {
  //         //       ...row,
  //         //       selected: true,
  //         //       amountreceived: (row.amountreceived) + deductAmount, // Received = payment amount
  //         //       // balanceAmount: deductAmount, // Balance = 0
  //         //     }
  //         //   : {
  //         //       ...row,
  //         //       selected: false,
  //         //       amountreceived: row.amountreceivedValue, // Reset received
  //         //       balanceAmount: row.balanceAmountValue, // Balance = payment amount
  //         //       // balanceAmount: row.balanceAmount + paymentAmount, // Balance = payment amount
  //         //     };
  //       }
  //       return row;
  //     })
  //   );
  // };
  const handleCheckboxChange = (id, isChecked) => {
    let remainingPayment = paymentAmount;

    setPaymentSettledRows((prevData) =>
      prevData.map((row) => {
        if (id.some((data) => data == row._id)) {
          // console.log(row, "row")
          const deductAmount = Math.min(row.balanceAmount, remainingPayment);

          // // Update the row's balanceAmount and receiveAmount
          row.balanceAmount -= deductAmount;
          row.amountreceived += row.amountreceived + deductAmount;
          // // Subtract from the remaining payment
          remainingPayment -= deductAmount;
          return isChecked
            ? {
                ...row,
                selected: true,
                // Received = payment amount
                // balanceAmount: deductAmount, // Balance = 0
              }
            : {
                ...row,
                selected: false,
                amountreceived: row.amountreceivedValue, // Reset received
                balanceAmount: row.balanceAmountValue, // Balance = payment amount
                // balanceAmount: row.balanceAmount + paymentAmount, // Balance = payment amount
              };
        }
        return row;
      })
    );
  };

  const paymentDataTable =
    payment_settled_list && payment_settled_list.length > 0
      ? payment_settled_list.map((data, index) => {
          // const netAmount = data.NetAmount.replace(/\d(?=(?:\d{3})+$)/g, '$&,');

          return {
            _id: data._id,
            key: index + 1,
            siId: data.siId,
            netTotalAmountValue: data.netTotalAmount,
            salesinvoiceNoValue: data.salesinvoiceNo,
            amountreceivedValue: 0,
            // amountreceivedValue: data.amountreceived,
            balanceAmountValue: data.balanceAmount,
            netTotalAmount: data.netTotalAmount,
            selected: false,
            salesinvoiceNo: (
              <p
                style={{
                  fontFamily: "Poppins",
                }}
              >
                {data.salesinvoiceNo}{" "}
              </p>
            ),
            salesinvoiceDate: data.salesinvoiceDate
              ? moment(data.salesinvoiceDate).format("DD-MM-YYYY")
              : "",
            salesinvoiceDateValue: data.salesinvoiceDate
              ? moment(data.salesinvoiceDate).format("YYYY-MM-DD")
              : "",
            createdAtValue: data.createdAt
              ? moment(data.createdAt).format("YYYY-MM-DD")
              : "",
            authorizedsignature: data.authorizedsignature,
            dueDate: (
              <p
                style={{
                  fontFamily: "Poppins",
                }}
              >
                {" "}
                {data.dueDate
                  ? moment(data.dueDate).format("DD-MM-YYYY")
                  : "--"}
              </p>
            ),
            dueDateValue: data.dueDate
              ? moment(data.dueDate).format("YYYY-MM-DD")
              : "--",
            autoamountroundoff: data.autoamountroundoff,
            beforeautoroundoffamount: data.beforeautoroundoffamount,
            charge: data.charge,
            createdAt: (
              <p
                style={{
                  fontFamily: "Poppins",
                }}
              >
                {data.createdAt
                  ? moment(data.createdAt).format("DD-MM-YYYY")
                  : ""}
              </p>
            ),
            createdBy: data.createdBy,
            financialyearId: data.financialyearId,
            isHistory: data.isHistory,
            // partyId: data.partyId,
            items: data.items,
            notes: data.notes,
            organizationId: data.organizationId,
            partyAddress: data.partyAddress,
            subtotalamount: data.subtotalamount,
            taxableAmonut: data.taxableAmonut,
            balanceAmount: data.balanceAmount,
            amountreceivedmode: data.amountreceivedmode,
            amountreceived: 0,
            // amountreceived: data.amountreceived,
            termsandconditions: data.termsandconditions,
            totaltax: data.totaltax,
            totaltaxableValue: data.totaltaxableValue,
            transActionType: data.transActionType,
            type: data.type,
            updatedAt: data.updatedAt,
            vendorAddress: data.vendorAddress,
            vendorCity: data.vendorCity,
            billStatus: data.billStatus,
            partyId: data.partyId,
            partyName: (
              <p
                style={{
                  fontFamily: "Poppins",
                  textTransform: "capitalize",
                }}
              >
                {data.partyName}
              </p>
            ),
            partyNameValue: data.partyName,
            status: (
              <Badge
                className={
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
                    : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
                }
              >
                {data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (paymentDataTable && paymentDataTable.length > 0) {
      setPaymentSettledRows(paymentDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payment_settled_list]);

  // /search
  const [search, setSearch] = useState("");
  const [tableLoading, setTableLoading] = useState(false);
  const handleSearch = (event) => {
    const filteredRows = paymentDataTable
      .filter((row) =>
        row.salesinvoiceNoValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setPaymentSettledRows(filteredRows);
  };

  const selectedRowsList =
    paymentSettledRows.length > 0 &&
    paymentSettledRows.filter(
      (data) => data.amountreceived !== data.amountreceivedValue
    );
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  //create payment in api
  const createPaymentInApi = () => {
    if (simpleValidator.current.allValid()) {
      if (
        paymentMode === "66c9bd6fb3fca462ca48a880" ||
        paymentMode === "66c9bd7bb3fca462ca48a882" ||
        paymentMode === "679331b9c4e15919fa3a8b54" ||
        paymentMode === "67933210c4e15919fa3a8b56" ||
        paymentMode === "67933226c4e15919fa3a8b58"
      ) {
        setIsButtonDisabled(true);
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 4000);
        const paymentDetails = {
          organizationId: organizationId,
          partyId: partyList,
          enterPaymentAmount: parseInt(paymentAmount),
          paymentDate: paymentDate
            ? moment(paymentDate).format("YYYY-MM-DD")
            : "",
          paymentModeId: paymentMode,
          // if payment mode bank or cheque means provide accountId
          accountId: accountList.length == 0 ? "" : accountList,
          isType:
            prefix_settings_list && prefix_settings_list.isEnable === true
              ? "isPaymentIn"
              : "",
          paymentNo: paymentInNo,
          currentBalance: currentBalance,
          notes: paymentInData.description,
          salesInvoices:
            selectedRowsList &&
            selectedRowsList.length > 0 &&
            selectedRowsList[0].createdAt
              ? selectedRowsList.map((data) => {
                  return {
                    siId: data._id,
                    siDate: data.createdAtValue,
                    dueDate: data.dueDateValue,
                    invoiceNumber: data.salesinvoiceNoValue,
                    invoiceAmount: data.netTotalAmountValue,
                    invoicePendingAmount: data.balanceAmount,
                    amountSettled: data.amountreceived,
                  };
                })
              : [],
          createdBy: createdById,
        };
        const paymentListArray = Object.keys(paymentDetails).forEach(
          (k) =>
            (paymentDetails[k] === undefined || paymentDetails[k] === "") &&
            delete paymentDetails[k]
        );
        console.log(paymentListArray);
        console.log(paymentDetails, "paymentDetails");
        api
          .post("/org/addpaymentin", paymentDetails)
          .then((res) => {
            dispatch(loadPaymentInList({ organizationId: organizationId }));
            toast.success("Payment in created successfully");
            setTimeout(() => {
              history.push("/payment-in");
            }, 2500);
            return res.data;
          })
          .catch((error) => {
            const errorMsg =
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.message) ||
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.error);
            toast.error(
              errorMsg || "There is a an issue while adding the purchase"
            );
            Promise.reject(error);
          });
      } else {
        setIsButtonDisabled(true);
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 4000);
        const paymentDetails = {
          organizationId: organizationId,
          partyId: partyList,
          enterPaymentAmount: parseInt(paymentAmount),
          paymentDate: paymentDate
            ? moment(paymentDate).format("YYYY-MM-DD")
            : "",
          paymentModeId: paymentMode == "Cash" ? paymentModeId : paymentMode,
          // if payment mode bank or cheque means provide accountId
          // accountId: accountList,
          paymentNo: paymentInNo,
          notes: paymentInData.description,
          currentBalance: currentBalance,
          isType:
            prefix_settings_list && prefix_settings_list.isEnable === true
              ? "isPaymentIn"
              : "",
          salesInvoices:
            selectedRowsList &&
            selectedRowsList.length > 0 &&
            selectedRowsList[0].createdAt
              ? selectedRowsList.map((data) => {
                  return {
                    siId: data._id,
                    siDate: data.createdAtValue,
                    dueDate: data.dueDateValue,
                    invoiceNumber: data.salesinvoiceNoValue,
                    invoiceAmount: data.netTotalAmountValue,
                    invoicePendingAmount: data.balanceAmount,
                    amountSettled: data.amountreceived,
                  };
                })
              : [],
          createdBy: createdById,
        };
        const paymentListArray = Object.keys(paymentDetails).forEach(
          (k) =>
            (paymentDetails[k] === undefined || paymentDetails[k] === "") &&
            delete paymentDetails[k]
        );
        console.log(paymentListArray);
        console.log(paymentDetails, "paymentDetails");
        api
          .post("/org/addpaymentin", paymentDetails)
          .then((res) => {
            dispatch(loadPaymentInList({ organizationId: organizationId }));
            toast.success("Payment in created successfully");
            setTimeout(() => {
              history.push("/payment-in");
            }, 2500);
            return res.data;
          })
          .catch((error) => {
            const errorMsg =
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.message) ||
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.error);
            toast.error(
              errorMsg || "There is a an issue while adding the purchase"
            );
            Promise.reject(error);
          });
      }

      // dispatch(createPaymentInList(paymentDetails));
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  console.log(paymentInData, "paymentInData");
  console.log(updatedPaymentData, "updatedPaymentData");
  console.log(currentBalance, "currentBalance");

  //create payment in api
  const updatePaymentInApi = () => {
    if (simpleValidator.current.allValid()) {
      if (
        paymentMode === "66c9bd6fb3fca462ca48a880" ||
        paymentMode === "66c9bd7bb3fca462ca48a882" ||
        paymentMode === "679331b9c4e15919fa3a8b54" ||
        paymentMode === "67933210c4e15919fa3a8b56" ||
        paymentMode === "67933226c4e15919fa3a8b58"
      ) {
        setIsButtonDisabled(true);
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 4000);
        const paymentDetails = {
          paymentInId: paymentInData._id,
          organizationId: organizationId,
          enterPaymentAmount: parseInt(paymentAmount),
          paymentDate: paymentDate
            ? moment(paymentDate).format("YYYY-MM-DD")
            : "",
          partyId: !isEmpty(paymentInData.partyId)
            ? paymentInData.partyId
            : partyList,
          currentBalance:
            updatedCurrentBalance !== ""
              ? updatedCurrentBalance
              : currentBalance,
          paymentModeId: !isEmpty(paymentModeId) ? paymentModeId : paymentMode,
          isType:
            prefix_settings_list && prefix_settings_list.isEnable === true
              ? "isPaymentIn"
              : "",
          // if payment mode bank or cheque means provide accountId
          accountId: !isEmpty(paymentInData.accountId)
            ? paymentInData.accountId
            : accountList.length == 0
            ? ""
            : accountList,
          paymentNo: paymentInNo,
          notes: paymentInData.description,
          salesInvoices:
            selectedRowsList &&
            selectedRowsList.length > 0 &&
            selectedRowsList[0].createdAt
              ? selectedRowsList.map((data) => {
                  return {
                    siId: data._id,
                    // _id: data._id,
                    siDate: data.createdAtValue,
                    dueDate: data.dueDateValue,
                    invoiceNumber: data.salesinvoiceNoValue,
                    invoiceAmount: data.netTotalAmount,
                    invoicePendingAmount: data.balanceAmount,
                    amountSettled: data.amountreceived,
                  };
                })
              : [],
          updatedBy: createdById,
        };
        const paymentListArray = Object.keys(paymentDetails).forEach(
          (k) =>
            (paymentDetails[k] === undefined || paymentDetails[k] === "") &&
            delete paymentDetails[k]
        );
        console.log(paymentListArray);
        api
          .post("/org/editpaymentin", paymentDetails)
          .then((res) => {
            dispatch(loadPaymentInList({ organizationId: organizationId }));
            toast.success("Payment in updated successfully");
            setTimeout(() => {
              history.push("/payment-in");
            }, 2500);
            return res.data;
          })
          .catch((error) => {
            const errorMsg =
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.message) ||
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.error);
            toast.error(
              errorMsg || "There is a an issue while adding the purchase"
            );
            Promise.reject(error);
          });
      } else {
        setIsButtonDisabled(true);
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 4000);
        const paymentDetails = {
          paymentInId: paymentInData._id,
          organizationId: organizationId,
          enterPaymentAmount: paymentInData.paymentAmount
            ? paymentInData.paymentAmount
            : parseInt(paymentAmount),
          paymentDate: paymentDate
            ? moment(paymentDate).format("YYYY-MM-DD")
            : "",
          partyId: !isEmpty(paymentInData.partyId)
            ? paymentInData.partyId
            : partyList,
          paymentModeId: paymentMode == "Cash" ? paymentModeId : paymentMode,
          isType:
            prefix_settings_list && prefix_settings_list.isEnable === true
              ? "isPaymentIn"
              : "",
          // if payment mode bank or cheque means provide accountId
          // accountId: accountList,
          currentBalance:
            updatedCurrentBalance !== ""
              ? updatedCurrentBalance
              : currentBalance,
          paymentNo: paymentInNo,
          notes: paymentInData.description,
          salesInvoices:
            selectedRowsList &&
            selectedRowsList.length > 0 &&
            selectedRowsList[0].createdAt
              ? selectedRowsList.map((data) => {
                  return {
                    siId: data._id,
                    // _id: data._id,
                    siDate: data.createdAtValue,
                    dueDate: data.dueDateValue,
                    invoiceNumber: data.salesinvoiceNoValue,
                    invoiceAmount: data.netTotalAmount,
                    invoicePendingAmount: data.balanceAmount,
                    amountSettled: data.amountreceived,
                  };
                })
              : [],
          updatedBy: createdById,
        };
        const paymentListArray = Object.keys(paymentDetails).forEach(
          (k) =>
            (paymentDetails[k] === undefined || paymentDetails[k] === "") &&
            delete paymentDetails[k]
        );
        console.log(paymentListArray);
        api
          .post("/org/editpaymentin", paymentDetails)
          .then((res) => {
            dispatch(loadPaymentInList({ organizationId: organizationId }));
            toast.success("Payment in updated successfully");
            setTimeout(() => {
              history.push("/payment-in");
            }, 2500);
            return res.data;
          })
          .catch((error) => {
            const errorMsg =
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.message) ||
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.error);
            toast.error(
              errorMsg || "There is a an issue while adding the purchase"
            );
            Promise.reject(error);
          });
      }

      // dispatch(createPaymentInList(paymentDetails));
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //end

  //updated data

  useEffect(() => {
    if (updatedPaymentData) {
      const accountHolderName =
        (updatedPaymentData && !isEmpty(updatedPaymentData.accountDetails)) ||
        updatedPaymentData.accountDetails !== null
          ? updatedPaymentData.accountDetails.accountName
          : "";
      setPaymentDate(updatedPaymentData.paymentDate);
      setPaymentMode(updatedPaymentData.paymentModeId);
      setPartyList(updatedPaymentData.partyName);
      setAccountList(accountHolderName);
      setPaymentInData({
        ...paymentInData,
        _id: updatedPaymentData._id,
        partyId: updatedPaymentData.partyId,
        accountId: updatedPaymentData.accountId,
        // paymentModeId: updatedPaymentData.paymentModeId,
        paymentAmount: "",
        paymentInNo: updatedPaymentData.paymentNo,
        description: updatedPaymentData.notes,
      });
      setUpdatedCurrentBalance(
        updatedPaymentData && updatedPaymentData.currentBalance !== undefined
          ? updatedPaymentData
          : ""
      );
      setPaymentModeId(updatedPaymentData.paymentModeId);
      setPaymentAmount(updatedPaymentData.enterPaymentAmount);
      if (updatedPaymentData.paymentModeId !== "66c9bd5ab3fca462ca48a87e") {
        dispatch(
          loadPartyAccountList({
            organizationId: organizationId,
          })
        );
      }
      if (
        updatedPaymentData.partyId &&
        updatedPaymentData.salesInvoices.length > 0
      ) {
        dispatch(
          loadPaymentSettledList({
            organizationId: organizationId,
            partyId: updatedPaymentData.partyId,
          })
        );
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedPaymentData]);

  //Calculate totals

  const calculateTotals = (row) => {
    let netTotalAmount = 0;
    let amountreceived = 0;

    row.forEach((data) => {
      netTotalAmount += parseFloat(data.netTotalAmount) || 0;
      amountreceived += parseFloat(data.amountreceived) || 0;
    });

    return { netTotalAmount, amountreceived };
  };

  const [totals, setTotals] = useState({
    netTotalAmount: 0,
    amountreceived: 0,
  });

  useEffect(() => {
    if (paymentSettledRows && paymentSettledRows.length > 0) {
      const totalValues = calculateTotals(paymentSettledRows);
      setTotals(totalValues);
      // if (paymentAmount || paymentAmount == "") {
      //   updateTable(paymentSettledRows, paymentAmount);
      //   setTableLoading(true);
      //   setTimeout(() => {
      //     setTableLoading(false);
      //   }, 2000);
      // } else if (
      //   updatedPaymentData &&
      //   updatedPaymentData !== undefined &&
      //   updatedPaymentData.enterPaymentAmount
      // ) {
      //   updateTable(paymentSettledRows, updatedPaymentData.enterPaymentAmount);
      //   setTableLoading(true);
      //   setTimeout(() => {
      //     setTableLoading(false);
      //   }, 2000);
      // }
    }
    // if (selectedRowKeys.length > 0) {
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentSettledRows, paymentAmount]);

  const [isPrefixButtonDisabled, setIsPrefixButtonDisabled] = useState(false);

  //Prefix settings list
  const createPrefixSettings = () => {
    if (prefixSettings.prefix && prefixSettings.seqNo) {
      setIsPrefixButtonDisabled(true);
      setTimeout(() => {
        setIsPrefixButtonDisabled(false);
      }, 6000);
      const prefixList = {
        organizationId: organizationId,
        prefix: prefixSettings.prefix,
        sequenceNo: prefixSettings.seqNo,
        isEnable: invoiceShow ? true : false,
        isType: "isPaymentIn",
        createdBy: createdById,
      };
      api
        .post("/org/addnewsequenceno", prefixList)
        .then((res) => {
          dispatch(loadPrefixSettingsList(paymentPrefixList));
          toast.success("Prefix updated successfully");
          setSettingsFieldModal(false);
          const orgLastInvoiceNo = !isEmpty(prefixSettings.seqNo)
            ? prefixSettings.prefix + "" + prefixSettings.seqNo
            : !isEmpty(updatedPaymentData) && updatedPaymentData !== undefined
            ? updatedPaymentData.paymentNo
            : prefix_settings_list.lastprefixName +
              "" +
              prefix_settings_list.lastsequenceNo;
          setPaymentInNo(orgLastInvoiceNo);
          setPrefixValidations(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(errorMsg || "there is an issue while adding prefix");
          return Promise.reject(error);
        });
    } else {
      setSettingsFieldModal(true);
      setPrefixValidations(true);
    }
  };

  //prefix setting value listed

  useEffect(() => {
    if (prefix_settings_list && prefix_settings_list.isEnable === true) {
      setPrefixSettings({
        ...prefixSettings,
        prefix: prefix_settings_list.lastprefixName,
        seqNo: prefix_settings_list.lastsequenceNo,
      });
      if (prefix_settings_list.isEnable === true) {
        setInvoiceShow(true);
      } else {
        setInvoiceShow(false);
      }
      // const orgLastInvoiceNo =
      //   prefix_settings_list.lastprefixName +
      //   "" +
      //   prefix_settings_list.lastsequenceNo;
      const orgLastInvoiceNo =
        !isEmpty(updatedPaymentData) && updatedPaymentData !== undefined
          ? updatedPaymentData.paymentNo
          : prefix_settings_list.lastprefixName +
            "" +
            prefix_settings_list.lastsequenceNo;

      // setPaymentInData({
      //   ...paymentInData,
      //   paymentInNo: orgLastInvoiceNo,
      // });
      setPaymentInNo(orgLastInvoiceNo);
    } else {
      const orgLastInvoiceNo =
        !isEmpty(updatedPaymentData) && updatedPaymentData !== undefined
          ? updatedPaymentData.paymentNo
          : "";
      setPaymentInNo(orgLastInvoiceNo);
      setPrefixSettings({
        ...prefixSettings,
        prefix: "",
        seqNo: "",
      });
      setInvoiceShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix_settings_list]);

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  //onload
  useBeforeUnload({
    when: !isEmpty(paymentInNo),
    message: "Are you sure you want to leave?",
  });

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Create Payment In | Mbook</title>
        </MetaTags>
      </div>
      {media === "xxl" ||
      media === "xl" ||
      media === "md" ||
      media === "lg" ||
      media === "sm" ? (
        <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-12px",
          }}
          onClick={() => setPaymentFaq(!paymentFaq)}
          icon={<QuestionCircleOutlined />}
        />
      ) : (
        ""
      )}

      <Row>
        <Col span={24} className="border-solid pb-3 rounded-sm bg-[#ffffff]">
          <div
            className={
              media === "xxl" ||
              media === "xl" ||
              media === "md" ||
              media === "lg"
                ? "font-poppins flex justify-between pl-[20px] pr-[20px] mt-4"
                : "font-poppins flex flex-col pl-[20px] pr-[20px] mt-4"
            }
          >
            <div
              className="flex"
              style={{
                fontFamily: "Poppins",
              }}
            >
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1 className="text-[18px] ml-2 mt-1 font-semibold">
                Record Payment In
              </h1>
            </div>
            <div
              className={
                media === "xxl" ||
                media === "xl" ||
                media === "md" ||
                media === "lg"
                  ? "flex"
                  : media === "xs"
                  ? "flex flex-col mt-2"
                  : "flex mt-2"
              }
              style={{
                fontFamily: "Poppins",
              }}
            >
              <Tooltip
                title="Introducing custom fields -> Now you can add custom party fields like Drug licence number, ID, etc.,"
                placement="bottom"
                rootClassName="text-[12px]"
              >
                <div
                  onClick={() => setSettingsFieldModal(true)}
                  className={
                    media === "xxl" ||
                    media === "xl" ||
                    media === "md" ||
                    media === "lg" ||
                    media === "sm"
                      ? "border rounded-md mr-3 pt-1.5 pb-1.5 pr-6 pl-6 cursor-pointer"
                      : "border rounded-md mr-3 text-center mb-2 pt-1.5 pb-1.5 pr-6 pl-6 cursor-pointer"
                  }
                >
                  Settings
                  {media === "xxl" ||
                  media === "xl" ||
                  media === "md" ||
                  media === "lg" ||
                  media === "sm" ? (
                    <SettingOutlined className="pl-2" />
                  ) : (
                    ""
                  )}
                </div>
              </Tooltip>
              <div
                onClick={() => {
                  setPageRouting(true);
                  setCancelConfirmation(true);
                }}
                className={
                  media === "xxl" ||
                  media === "xl" ||
                  media === "md" ||
                  media === "lg" ||
                  media === "sm"
                    ? "border rounded-md hover:bg-[#efefef] ml-3 pl-8 pr-8 p-1 cursor-pointer"
                    : "border rounded-md hover:bg-[#efefef] text-center mb-2 mr-3 pl-8 pr-8 p-1 cursor-pointer"
                }
              >
                Cancel
              </div>
              {updatedPaymentData && updatedPaymentData.partyName ? (
                <div
                  onClick={() => updatePaymentInApi()}
                  className={
                    media === "xxl" ||
                    media === "xl" ||
                    media === "md" ||
                    media === "lg" ||
                    media === "sm"
                      ? "border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-8 pr-8 p-1.5 cursor-pointer"
                      : "border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md text-center mr-3 pl-8 pr-8 p-1.5 cursor-pointer"
                  }
                  style={{
                    pointerEvents: isButtonDisabled ? "none" : "",
                    opacity: isButtonDisabled ? 2 : "",
                  }}
                >
                  Update
                </div>
              ) : (
                <div
                  onClick={() => createPaymentInApi()}
                  className={
                    media === "xxl" ||
                    media === "xl" ||
                    media === "md" ||
                    media === "lg" ||
                    media === "sm"
                      ? "border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-8 pr-8 p-1.5 cursor-pointer"
                      : "border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] text-center rounded-md mr-3 pl-8 pr-8 p-1.5 cursor-pointer"
                  }
                  style={{
                    pointerEvents: isButtonDisabled ? "none" : "",
                    opacity: isButtonDisabled ? 2 : "",
                  }}
                >
                  Save
                </div>
              )}
            </div>
          </div>
        </Col>

        <Col
          span={24}
          className={
            (windowDimensions.height >= 700 &&
              windowDimensions.height <= 767) ||
            (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "add-payment-in-main-large-device pr-1 pl-1 pt-3"
              : windowDimensions.height > 830 && windowDimensions.height < 900
              ? "add-payment-in-main-extra-large-device pr-1 pl-1 pt-3"
              : windowDimensions.height > 900 && windowDimensions.height < 1000
              ? "add-payment-in-main-extra-extra-large-device pr-1 pl-1 pt-3"
              : windowDimensions.height > 1000
              ? "add-payment-in-main-extra-infinite-large-device pr-1 pl-1 pt-3"
              : "add-payment-in-main pr-1 pl-1 pt-3"
          }
        >
          <Row>
            <Col
              md={10}
              sm={24}
              lg={10}
              xl={10}
              xxl={10}
              xs={24}
              className={
                windowDimensions.height >= 700 && windowDimensions.height <= 800
                  ? "border border-solid h-[250px] border-lightgray-200 p-3 rounded-md bg-[#ffffff]"
                  : "border border-solid border-lightgray-200 p-3 rounded-md bg-[#ffffff]"
              }
            >
              <div className="w-[100%] mb-3">
                <Typography className="input-label text-[12px] mb-[-4px]">
                  Party Name <p className="text-[red] ml-1">*</p>
                </Typography>
                <Select
                  name="partyList"
                  value={partyList}
                  onChange={(e) => {
                    setPartyList(e);
                    // if (e) {
                    dispatch(
                      loadPaymentSettledList({
                        partyId: e,
                        organizationId: organizationId,
                      })
                    );
                    setPartyListSelected(true);
                    setTimeout(() => {
                      setPartyListSelected(false);
                    }, 1000);
                    // }
                  }}
                  placeholder="Select Party"
                  style={{
                    fontFamily: "Poppins",
                  }}
                  suffixIcon={<SearchOutlined />}
                  options={partyOptions}
                  className="w-[100%] h-[40px]"
                />
                <p className="text-[red] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "partyList",
                    partyList,
                    "required"
                  )}
                </p>
                <p
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="text-[11px] mt-1"
                >
                  {currentBalance
                    ? "Current Balance. " +
                      "₹ " +
                      currentBalance.toLocaleString("en-IN")
                    : ""}
                </p>
              </div>
              <div className="w-[100%] mt-4 mb-2">
                <Typography className="input-label text-[12px] mb-[-4px]">
                  Payment <p className="text-[red] ml-1">*</p>
                </Typography>
                <Input
                  name="paymentAmount"
                  value={paymentAmount}
                  onChange={handlePaymentAmountChange}
                  placeholder="0"
                  prefix={"₹"}
                  className="p-2"
                  // style={{
                  //   fontFamily: "Poppins",
                  // }}
                />
                <p className="text-[red] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "paymentAmount",
                    paymentAmount,
                    "required"
                  )}
                </p>
              </div>
            </Col>
            <Col md={14} sm={24} lg={14} xs={24}>
              <Row
                className={
                  (media === "xxl" ||
                    media === "xl" ||
                    media === "md" ||
                    media === "lg") &&
                  windowDimensions.height > 700
                    ? "ml-3 h-[250px] border border-solid border-lightgray-200 p-3 rounded-md bg-[#ffffff]"
                    : "mt-3 border border-solid border-lightgray-200 p-3 rounded-md bg-[#ffffff]"
                }
              >
                <Col md={8} sm={12} lg={8} xs={12} className="pr-3">
                  <Typography className="input-label text-[12px] mb-[-3px]">
                    Payment Date <p className="text-[red] ml-1">*</p>
                  </Typography>
                  <DatePicker
                    selected={paymentDate}
                    className="rounded-md w-[95%] mt-[-3px] border border-1 h-[40px]"
                    onChange={(date) => setPaymentDate(date)}
                    icon={
                      <BiCalendar
                        //   size={30}
                        className="top-[2px] text-[16px] right-[10px] text-[#9e9e9e]"
                      />
                    }
                    style={{
                      fontFamily: "Poppins",
                    }}
                    showIcon={true}
                    placeholderText="Select Date"
                  />
                  <p className="text-[red] text-[12px] mt-1">
                    {simpleValidator.current.message(
                      "paymentDate",
                      paymentDate,
                      "required"
                    )}
                  </p>
                </Col>
                <Col md={8} sm={12} lg={8} xs={12} className="pr-4 mb-2">
                  <Typography className="input-payment-in-label text-[12px] mb-[-4px]">
                    Payment Mode <p className="text-[red] ml-1">*</p>
                  </Typography>
                  <Select
                    name="paymentMode"
                    value={paymentMode}
                    onChange={(e) => {
                      setPaymentMode(e);
                      if (e !== "66c9bd5ab3fca462ca48a87e") {
                        dispatch(
                          loadPartyAccountList({
                            organizationId: organizationId,
                          })
                        );
                      }
                    }}
                    placeholder="Select Payment Mode"
                    style={{
                      fontFamily: "Poppins",
                    }}
                    options={
                      recordsMetaData ? recordsMetaData.paymentModeOptions : []
                    }
                    className="w-[100%] h-[40px]"
                  />
                  <p className="text-[red] text-[12px] mt-1">
                    {simpleValidator.current.message(
                      "paymentMode",
                      paymentMode,
                      "required"
                    )}
                  </p>
                </Col>
                {paymentMode === "Cash" ||
                paymentMode === "66c9bd5ab3fca462ca48a87e" ? (
                  ""
                ) : (
                  <Col md={8} sm={12} lg={8} xs={12} className="pr-4 mb-2">
                    <Typography className="input-payment-in-label text-[12px] mb-2">
                      Account
                    </Typography>
                    <Select
                      name="accountList"
                      value={accountList}
                      onChange={(e) => setAccountList(e)}
                      placeholder="Select Account"
                      style={{
                        fontFamily: "Poppins",
                      }}
                      options={partyAccountOptions}
                      className="w-[100%] h-[40px]"
                    />
                  </Col>
                )}

                <Col md={8} sm={12} lg={8} xs={12} className="pr-4 mb-2">
                  <Typography className="input-payment-in-label text-[12px] mb-[-4px]">
                    Payment Number <p className="text-[red] ml-1">*</p>
                  </Typography>
                  <Input
                    name="paymentInNo"
                    value={paymentInNo}
                    onChange={(e) => setPaymentInNo(e.target.value)}
                    placeholder="Enter payment number"
                    className="p-2"
                    style={{
                      fontFamily: "Poppins",
                    }}
                  />
                  <p className="text-[red] text-[12px] mt-1">
                    {simpleValidator.current.message(
                      "paymentInNo",
                      paymentInNo,
                      "required"
                    )}
                  </p>
                </Col>
                <Col
                  md={
                    !isEmpty(paymentMode) &&
                    paymentMode !== "66c9bd5ab3fca462ca48a87e"
                      ? 16
                      : 24
                  }
                  sm={24}
                  lg={
                    !isEmpty(paymentMode) &&
                    paymentMode !== "66c9bd5ab3fca462ca48a87e"
                      ? 16
                      : 24
                  }
                  xs={24}
                  className="mb-2 mt-1"
                >
                  <Typography className="input-payment-in-label text-[12px] mb-1">
                    Notes
                  </Typography>
                  <Input.TextArea
                    name="description"
                    value={paymentInData.description}
                    onChange={(e) => handlePaymentChange(e)}
                    placeholder="Enter Notes"
                    className="p-3"
                    style={{
                      fontFamily: "Poppins",
                    }}
                  />
                </Col>
              </Row>
            </Col>
            {partyListSelected === true ? (
              <Col span={24} className="text-center">
                <Spin size="large" className="mt-[70px]" />
                {/* <Spin size="large" fullscreen /> */}
              </Col>
            ) : payment_settled_list &&
              payment_settled_list.length > 0 &&
              !isEmpty(partyList) ? (
              <Col md={24} xl={24} xxl={24} sm={24} xs={24}>
                <Row className="bg-[white] mt-4 rounded-md border border-x-0 border-t-0 border-b-1">
                  <Col
                    md={24}
                    xl={24}
                    xxl={24}
                    sm={24}
                    xs={24}
                    className="pr-4 pl-4"
                  >
                    <Row className="pt-4 sales-invoice-filters-main">
                      <div>
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="mr-4 pt-1 text-[16px] font-semibold"
                        >
                          Settle Invoices with this payment
                        </div>
                      </div>
                      <Tooltip
                        rootClassName="text-[10px]"
                        title="Search Invoice Numebr"
                        placement="bottom"
                      >
                        {/* {searchOpen ? ( */}
                        <div className="filter-dropdown-filters">
                          <AutoComplete
                            style={{
                              marginRight: "10px",
                              fontSize: "11px",
                            }}
                            // onClick={() => setSearchOpen(false)}
                            className="w-[100%] border-none"
                          >
                            <Input
                              size="large"
                              placeholder="Search Invoice Number"
                              style={{
                                fontFamily: "Poppins",
                                minHeight: "35px",
                                fontSize: "11px",
                                border: "none",
                                borderRadius: "1px",
                              }}
                              addonBefore={
                                <SearchOutlined
                                  style={{
                                    borderRadius: "1px",
                                  }}
                                />
                              }
                              name="search"
                              value={search}
                              onChange={(e) => handleSearch(e)}
                            />
                          </AutoComplete>
                        </div>
                      </Tooltip>
                    </Row>
                  </Col>
                  <Col
                    md={24}
                    xl={24}
                    xxl={24}
                    sm={24}
                    xs={24}
                    className={
                      media === "xxl"
                        ? "pt-12 pr-4 pl-4 sales-invoice-orders mt-2 pb-10"
                        : "pt-5 pr-4 pl-4 sales-invoice-orders mt-2 pb-10"
                    }
                  >
                    <Table
                      style={{
                        overflow: "hidden",
                      }}
                      bordered
                      columns={HeaderData}
                      dataSource={
                        paymentSettledRows &&
                        paymentSettledRows.length > 0 &&
                        !isEmpty(paymentSettledRows[0].createdAt)
                          ? paymentSettledRows
                          : []
                      }
                      // expandable={{
                      //   expandedRowRender: expandedRowRender,
                      //   defaultExpandAllRows: false,
                      // }}

                      rowSelection={{
                        selectedRowKeys,
                        onSelectAll: (selectedRowKeys, selectedRows, row) => {
                          const newSelecteds = selectedRows.map((n) => n._id);
                          setSelectedRowKeys(newSelecteds);
                        },
                        onSelect: (selectedRowKey, selectedRows, row) => {
                          const selectedIndex = selectedRowKeys.indexOf(
                            selectedRowKey._id
                            // selectedRowKey._id
                          );

                          let newSelecteds = [];
                          if (selectedIndex === -1) {
                            newSelecteds = newSelecteds.concat(
                              selectedRowKeys,
                              selectedRowKey._id
                            );
                          } else if (selectedIndex === 0) {
                            newSelecteds = newSelecteds.concat(
                              selectedRowKeys.slice(1)
                            );
                          } else if (
                            selectedIndex ===
                            selectedRowKeys.length - 1
                          ) {
                            newSelecteds = newSelecteds.concat(
                              selectedRowKeys.slice(0, -1)
                            );
                            //   // let result = [];
                            //   // let paidAmount = paymentAmount;
                            //   // paymentSettledRows.forEach((arr1Obj) => {
                            //   //   let matchedObject =
                            //   //     row &&
                            //   //     row.find(
                            //   //       (arr2Obj) => arr2Obj._id == arr1Obj._id
                            //   //     );
                            //   //   if (matchedObject) {
                            //   //
                            //   //     result.push({ ...arr1Obj, ...matchedObject });
                            //   //   }
                            //   // });
                          } else if (selectedIndex > 0) {
                            newSelecteds = newSelecteds.concat(
                              selectedRowKeys.slice(0, selectedIndex),
                              selectedRowKeys.slice(selectedIndex + 1)
                            );
                          }

                          setSelectedRowKeys(newSelecteds);
                          handleCheckboxChange(newSelecteds, selectedRows);
                          // handleRowSelection(newSelecteds);
                        },
                      }}
                      loading={tableLoading ? true : false}
                      pagination={false}
                      rowKey={(record) => record._id}
                      rowClassName={"text-[12px]"}
                      // rootClassName="pointer-events-none opacity-1"
                      // pagination={{
                      //   defaultPageSize: 10,
                      //   showSizeChanger: true,
                      //   // pageSizeOptions: ["5", "10", "20", "30"],
                      // }}
                      sortDirections={"ascend"}
                      // loading={tableLoading ? true : false}
                      showSorterTooltip={"sorter-icon"}
                      scroll={{ x: 765 }}
                      footer={() => {
                        return (
                          <div className="flex flex-row mt-[-6px] mb-[-6px]">
                            <h1
                              style={{
                                fontFamily: "Poppins",
                              }}
                              className="w-[56%] text-[14px] mt-1 font-semibold"
                              // className="w-[66%] md:w-[65%] lg:w-[65%] xl:w-[65%] xxl:w-[65%] text-[14px] mt-1 font-semibold"
                            >
                              Total
                            </h1>
                            <div className="flex w-[24%]">
                              <p className="font-semibold">{"₹"}</p>
                              <h1
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="text-[14px] ml-1 font-semibold"
                              >
                                {totals && totals.netTotalAmount
                                  ? totals.netTotalAmount.toLocaleString(
                                      "en-IN"
                                    )
                                  : 0}
                              </h1>
                            </div>
                            <div className="flex w-[20%]">
                              <p className="font-semibold">{"₹"}</p>
                              <h1
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="text-[14px] ml-1 font-semibold"
                              >
                                {totals && totals.amountreceived
                                  ? totals.amountreceived.toLocaleString(
                                      "en-IN"
                                    )
                                  : 0}
                              </h1>
                            </div>
                          </div>
                        );
                      }}
                      // scroll={{ y: 200, x: 765 }}
                    />
                  </Col>
                </Row>
              </Col>
            ) : (
              <Col span={24} className="flex justify-center">
                <div>
                  <Image
                    preview={false}
                    src={PaymentOutLogo}
                    height={130}
                    width={450}
                  />
                  <h1 className="text-center mt-2 text-[18px] purchase-label font-semibold">
                    No Transactions yet!
                  </h1>
                  <p
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-center text-[#8d8d8d] mt-2 text-[14px]"
                  >
                    Select Party Name to view transactions
                  </p>
                </div>
              </Col>
            )}
          </Row>
        </Col>

        {/* settings Field Modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Payment In Settings"
          onOk={createPrefixSettings}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: isPrefixButtonDisabled ? true : false,
          }}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[14px]">
                Payment In Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvoiceShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1"
                  >
                    Prefix
                  </Typography>

                  <Input
                    name="prefix"
                    value={prefixSettings.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(prefixSettings.prefix) ? (
                    <p className="text-[red] text-[12px]">
                      The Prefix field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={8}>
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1"
                  >
                    Sequence Number
                  </Typography>

                  <Input
                    name="seqNo"
                    value={prefixSettings.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(prefixSettings.seqNo) ? (
                    <p className="text-[red] text-[12px]">
                      The seq no field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={24} className="mt-2">
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1"
                  >
                    Payment In Number:{" "}
                    {prefixSettings.prefix && prefixSettings.seqNo
                      ? prefixSettings.prefix + "" + prefixSettings.seqNo
                      : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
        <Modal
          open={paymentFaq}
          title="Payment"
          closeIcon
          maskClosable={false}
          onClose={() => setPaymentFaq(false)}
          onCancel={() => setPaymentFaq(false)}
          footer={(_, { CancelBtn }) => (
            <>
              <CancelBtn />
            </>
          )}
          width={600}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />

          <Collapse
            items={paymentFaqList}
            expandIcon={<DownCircleOutlined />}
            expandIconPosition="right"
            className="font-semibold"
            bordered
            style={{
              fontFamily: "Poppins",
            }}
          />
        </Modal>

        <Modal
          open={pageRouting}
          onOk={() => {
            setPageRouting(false);
            setCancelConfirmation(false);
            history.push("/payment-in");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => {
            setPageRouting(false);
            setCancelConfirmation(false);
          }}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div
            style={{
              fontFamily: "Poppins",
            }}
            className="text-center w-[100%]"
          >
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
            {cancelConfirmation ? (
              ""
            ) : (
              <p className="text-center text-[14px] mt-2">
                All unsaved changes will be lost!
              </p>
            )}
          </div>
        </Modal>
      </Row>

      {/* <Prompt
        when={!isEmpty(paymentInNo)}
        message="Are you sure you want to leave?"
      /> */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

CreatePaymentIn.propTypes = {
  location: PropTypes.any,
};

export default CreatePaymentIn;
